export default defineNuxtPlugin({
  parallel: true,
  async setup() {
    const config = useRuntimeConfig();
    const { default: mixpanel } = await import('mixpanel-browser');

    mixpanel.init(config.public.MIXPANEL_TOKEN, {
      debug: config.public.MIXPANEL_DEBUG,
    });

    return { provide: { mixpanel } };
  },
});
